import reqwest from "reqwest";
import { BASE_URL } from "../constants";

const AUTHORIZATION_KEY = "Authorization";
const ACCEPT_KEY = "Accept";
const CONTENT_TYPE_KEY = "Content-Type";
const CROSS_ORIGIN_KEY = "crossOrigin";
const HEADERS_KEY = "headers";
const METHOD_KEY = "method";
const TYPE_KEY = "type";

const APPLICATION_JSON = "application/json";
const APPLICATION_ZIP = "application/zip";
const TEXT_CSV = "text/csv";
const JSON_VALUE = "json";
const GET = "GET";
const POST = "POST";
const PUT = "PUT";
const DELETE = "DELETE";

const handleToken = (requestOptions) => {
  requestOptions[HEADERS_KEY]["X-Requested-With"] = "XMLHttpRequest";
  if (Rest.token) {
    requestOptions[HEADERS_KEY][AUTHORIZATION_KEY] = `Bearer ${Rest.token}`;
  }
};

const Rest = {
  token: null,

  doLogin(url, username, password) {
    const base64Credentials = btoa(`${username}:${password}`);
    const requestOptions = {
      url: BASE_URL + url,
      [TYPE_KEY]: JSON_VALUE,
      [METHOD_KEY]: GET,
      [CROSS_ORIGIN_KEY]: process.env.NODE_ENV !== "production",
      [HEADERS_KEY]: {
        [ACCEPT_KEY]: APPLICATION_JSON,
        "X-Requested-With": "XMLHttpRequest",
        [AUTHORIZATION_KEY]: `Basic ${base64Credentials}`
      }
    };

    return reqwest(requestOptions);
  },

  doGet(url, accept = APPLICATION_JSON) {
      const encodedURL = encodeURI(BASE_URL + url);

      const requestOptions = {
        url: encodedURL,
        [TYPE_KEY]: accept === TEXT_CSV ? "text" : accept === APPLICATION_ZIP ? "blob" : JSON_VALUE,
        [METHOD_KEY]: GET,
        [CROSS_ORIGIN_KEY]: process.env.NODE_ENV !== "production",
        [HEADERS_KEY]: {
          [ACCEPT_KEY]: accept
        }
      };
  
      handleToken(requestOptions);
  
      return reqwest(requestOptions);
  },

  doExport(url, accept) {
    const requestOptions = {
      method: "GET",
      responseType: "blob",
      headers: {
        Accept: accept
      }
    };

    handleToken(requestOptions);

    return fetch(BASE_URL + url, requestOptions);
  },

  doPost(url, data) {
    const requestOptions = {
      url: BASE_URL + url,
      [TYPE_KEY]: JSON_VALUE,
      [METHOD_KEY]: POST,
      [CROSS_ORIGIN_KEY]: process.env.NODE_ENV !== "production",
      [HEADERS_KEY]: {
        [ACCEPT_KEY]: APPLICATION_JSON,
        [CONTENT_TYPE_KEY]: APPLICATION_JSON
      },
      data
    };
    handleToken(requestOptions);
    return reqwest(requestOptions);
  },

  doPostFileUpload(url, data) {
    const requestOptions = {
      url: BASE_URL + url,
      [TYPE_KEY]: JSON_VALUE,
      [METHOD_KEY]: POST,
      [CROSS_ORIGIN_KEY]: process.env.NODE_ENV !== "production",
      [HEADERS_KEY]: {
        [ACCEPT_KEY]: APPLICATION_JSON,
        [CONTENT_TYPE_KEY]: APPLICATION_JSON
      },
      data: JSON.stringify(data)
    };
    handleToken(requestOptions);
    return reqwest(requestOptions);
  },

  doPut(url, data) {
    const requestOptions = {
      url: BASE_URL + url,
      [TYPE_KEY]: JSON_VALUE,
      [METHOD_KEY]: PUT,
      [CROSS_ORIGIN_KEY]: process.env.NODE_ENV !== "production",
      [HEADERS_KEY]: {
        [ACCEPT_KEY]: APPLICATION_JSON,
        [CONTENT_TYPE_KEY]: APPLICATION_JSON
      },
      data
    };
    handleToken(requestOptions);
    return reqwest(requestOptions);
  },

  doDelete(url, data) {
    const requestOptions = {
      url: BASE_URL + url,
      [TYPE_KEY]: JSON_VALUE,
      [METHOD_KEY]: DELETE,
      [CROSS_ORIGIN_KEY]: process.env.NODE_ENV !== "production",
      [HEADERS_KEY]: {
        [CONTENT_TYPE_KEY]: APPLICATION_JSON
      },
      data
    };
    handleToken(requestOptions);
    return reqwest(requestOptions);
  }
};

export default Rest;
